import axios, { AxiosRequestConfig } from 'axios';

interface FeedbackData {
    category: string;
    topic: string;
    details: string;
}

const API_BASE_URL = `${import.meta.env.VITE_API_URL}/api/settings/feedback`;

export const settingsService = {
    async submitFeedback(feedback: FeedbackData) {
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        const response = await axios.post(`${API_BASE_URL}`, feedback, { headers });
        return response.data;
    }
};
